<section class="py-14 md:py-24">
  <!-- Header -->
  <div class="flex flex-col items-start mb-[60px]" data-aos="fade-up">
    <span
      class="inline-flex items-center gap-2 rounded-full bg-[#353CD817] px-4 py-2 mb-[18px]"
    >
      <span
        class="text-[12px] leading-[18px] font-bold uppercase tracking-wider text-[#353CD8]"
      >
        {{ "talentSearchV2.faq.badge" | translate }}
      </span>
    </span>

    <h2
      class="text-[28px] md:text-[40px] lg:text-[52] leading-tight lg:leading-[56px] font-extrabold text-[#061430]"
      [innerHTML]="'talentSearchV2.faq.title' | translate | accent"
    ></h2>
  </div>

  <!-- FAQ list -->
  <div class="flex flex-col gap-4" data-aos="fade-up">
    <details
      *ngFor="let f of faqs; let i = index"
      class="rounded-xl border bg-[#E9F1FF] overflow-hidden"
      [open]="f.isOpen"
      (toggle)="f.isOpen = !f.isOpen"
    >
      <summary
        class="cursor-pointer flex items-center justify-between gap-4 text-startlist-none marker:hidden [&::-webkit-details-marker]:hidden p-6"
        [class.pb-4]="f.isOpen"
      >
        <span class="text-lg font-semibold text-[#0D0D12]">
          {{ i + 1 }}. {{ f.questionKey | translate }}
        </span>

        <app-icon
          class="text-[#2AED73]"
          [name]="f.isOpen ? 'tabler:minus' : 'tabler:plus'"
          size="24"
        />
      </summary>

      <p
        class="bg-white rounded-lg p-3 text-base text-[#3B4A6B] whitespace-pre-line mb-6 mx-6"
        [innerHTML]="f.answerKey | translate"
      ></p>
    </details>
  </div>
</section>
